export default {
  // Hero
  'hero.badge': 'About GBCOSPACK',
  'hero.title': 'Redefining Cosmetic Packaging Sourcing',
  'hero.subtitle':
    'We are a global B2B portal connecting cosmetic brands with a verified manufacturing alliance, making sourcing transparent, efficient, and reliable.',

  // Story
  'story.label': 'Our Story',
  'story.title': 'Built to bridge brands and factories',
  'story.p1':
    'GBCOSPACK was founded to solve a real problem in the cosmetic industry: sourcing packaging from overseas factories was opaque, fragmented, and risky. Brands struggled to verify suppliers, compare prices, or predict how a finish would actually look.',
  'story.p2':
    'We brought together a manufacturing alliance of large-scale, highly automated factories and standardized their product data into one searchable platform. Now, from a single place, you can browse, compare, preview finishing with AI, and request transparent quotations.',
  'story.p3':
    'Today we serve cosmetic brands, OEM/ODM companies, and distributors across more than 50 countries — helping them launch products faster and with far less risk.',

  // Mission
  'mission.label': 'Why We Exist',
  'mission.title': 'Our Mission & Vision',
  'mission.subtitle':
    'Three principles guide everything we build and every partner we bring on board.',
  'mission.m1.title': 'Our Mission',
  'mission.m1.desc':
    'Make cosmetic packaging sourcing transparent, efficient, and reliable by connecting brands directly with a verified manufacturing alliance.',
  'mission.m2.title': 'Our Vision',
  'mission.m2.desc':
    'Become the world\u2019s most trusted destination for cosmetic packaging — where every brand can source with total confidence.',
  'mission.m3.title': 'Our Commitment',
  'mission.m3.desc':
    'Every supplier is audited, every price is transparent, and every order is backed by multi-stage quality control from sample to shipment.',

  // Values
  'values.label': 'Our Core Values',
  'values.title': 'What we stand for',
  'values.subtitle':
    'These values shape how we verify suppliers, structure pricing, and support every customer.',
  'values.v1.title': 'Transparency',
  'values.v1.desc':
    'No hidden fees. Full cost breakdowns and standardized spec sheets for easy comparison.',
  'values.v2.title': 'Quality First',
  'values.v2.desc':
    'Multi-stage QC at factory and pre-shipment, with full traceability on every batch.',
  'values.v3.title': 'Reliability',
  'values.v3.desc':
    'Stable, automated mass production you can count on — order after order.',
  'values.v4.title': 'Innovation',
  'values.v4.desc':
    'AI finishing previews and image search make exploration faster than ever.',
  'values.v5.title': 'Global Partnership',
  'values.v5.desc':
    'Door-to-door logistics and local support for brands in 50+ countries.',
  'values.v6.title': 'Sustainability',
  'values.v6.desc':
    'Eco packaging options and responsible sourcing for a greener supply chain.',

  // Stats
  'stats.label': 'By the Numbers',
  'stats.title': 'Trusted at scale',
  'stats.subtitle': 'A track record built over decades of manufacturing and global trade.',
  'stats.s1.value': '20+',
  'stats.s1.label': 'Years of Manufacturing',
  'stats.s2.value': '1,000+',
  'stats.s2.label': 'Verified Suppliers',
  'stats.s3.value': '50,000+',
  'stats.s3.label': 'Product SKUs',
  'stats.s4.value': '50+',
  'stats.s4.label': 'Countries Served',

  // Milestones
  'milestones.label': 'Our Journey',
  'milestones.title': 'Milestones that shaped us',
  'milestones.subtitle':
    'From a single factory to a global manufacturing alliance.',
  'milestones.m1.title': 'First Factory Established',
  'milestones.m1.desc':
    'CosmePack Manufacturing Group begins integrated cosmetic packaging production.',
  'milestones.m2.title': 'Glass Container Specialization',
  'milestones.m2.desc':
    'Cristallo Glassworks launches high-transparency glass container lines.',
  'milestones.m3.title': 'Tube & Plastic Expansion',
  'milestones.m3.desc':
    'FlexoTech and PolyForm join, adding laminate tubes and PET/PP bottles to the alliance.',
  'milestones.m4.title': 'Global Portal Launch',
  'milestones.m4.desc':
    'GBCOSPACK opens as a unified B2B sourcing platform for brands worldwide.',
  'milestones.m5.title': 'AI Preview & Image Search',
  'milestones.m5.desc':
    'AI finishing preview and similar-image search make exploration instant.',
  'milestones.m6.title': '50+ Countries Served',
  'milestones.m6.desc':
    'The alliance now supplies cosmetic packaging to brands on five continents.',

  // CTA
  'cta.label': 'Work With Us',
  'cta.title': 'Let\u2019s build your next product together',
  'cta.subtitle':
    'Whether you need a stock container or a fully custom design, our team is ready to guide you.',
  'cta.quote': 'Request a Quote',
  'cta.contact': 'Contact Our Team',
  'cta.browse': 'Browse Products',
};